import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateFontSizeOverride } from '../../modules/fontSizeOverride';
import WindowEventListener from '../WindowEventListener';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class FontSizeChange extends Component {
  receiveMessage = ({ origin, data: { type, payload } }) => {
    const { dispatch } = this.props;
    const matchURL = /https?:\/\/+([a-z])*\.*([a-z])*\.*(isf)+\.*[io]*(com)*/;
    /* When the page reloads or when user changes the font sizes in ISF,
     * it will trigger this dispatch
     * and update the bestige font size.
     */
    if (type === 'SET_FONT_SIZE_REQUEST') {
      if (origin.match(matchURL) && payload) {
        dispatch(updateFontSizeOverride(`${payload}px`));
      }
    }
  }

  render() {
    return <WindowEventListener event="message" onEvent={this.receiveMessage} />;
  }
}

FontSizeChange.propTypes = propTypes;

export default connect()(FontSizeChange);
